<template>
  <div class="">
    <v-header :inputName='Name' style="padding: -90px;"></v-header>
    <div class="manpin">
      <div class="miansdas">
        <!-- <img src="../../assets/img/topxiang.jpg"> -->
        <!-- <span></span> -->
      </div>
      <v-massage ref="massage" style="width: 1280px;padding-top: 0;"></v-massage>
      <div class="main centen container">
        <div class="main_l">
          <jibenxinxi></jibenxinxi>
        </div>
        <!-- 在class为main_r里面写页面就行 -->
        <div class="main_r">
          <div class="mainr_top">
            <img src="../../assets/gerenzhongxin/geren16.png">
            志愿填报
          </div>
          <div class="tiaobaodan">
            <div class="tbheader">
              <div class="item">报考批次</div>
              <div class="item">科类</div>
              <div class="item">2026批次线</div>
              <div class="item">志愿个数</div>
              <!-- <div class="item">每组专业个数</div> -->
              <div class="item">填报</div>
            </div>
            <div class="tbrow" v-for="item in data">
              <div class="item">
              {{item.provincialBatch}}<div class="tbt" v-if="item.provincialBatch.indexOf('提前')!=-1">?</div></div>
              <div class="item">{{SUBJECTTYPEOBJ[item.provincialSubject]}}</div>
              <div class="item">{{item.provincialScore}}</div>
              <div class="item">{{item.provincialNum}}个</div>
              <!-- <div class="item">-</div> -->
              <div class="item"><div class="tbbtn" @click="kaishitianbao1(item)">一键填报</div></div>
            </div>


            <!-- <div class="tiaobaodan_index" v-for="item in data">
              <div class="tian_top">
                {{item.provincialBatch}}
              </div>
              <div class="xiamian">
                <span>科目:{{SUBJECTTYPEOBJ[item.provincialSubject]}}</span>
                <div class="tian_fen">
                  <span>{{item.provincialScore}}</span>
                  <label>分</label>
                </div>
                <label>省控线</label>
                <div class="kaishi" @click="kaishitianbao(item)">
                  开始填报
                </div>
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </div>
    <item7></item7>
    <zuoxuanfu1></zuoxuanfu1>
    <openmask :title="open.title" v-if="show"   @close="close"  :maskcontent="open.content"></openmask>
  </div>
</template>

<script>
  import vHeader from "../../components/vHeader.vue";
  import item7 from "../../components/item7.vue";
  import zuoxuanfu1 from '../../components/zuoxuanfu1.vue'
  import jibenxinxi from '../../components/jibenxinxi.vue'
  import openmask from '../../components/mask.vue'
  import vMassage from "../../components/vMassage.vue";
  export default {
    name: "",
    components: {
      vHeader,
      item7,
      zuoxuanfu1,
      jibenxinxi,
      openmask,
      vMassage
    },
    data() {
      return {
        // 导航选中
        Name: 4,
        bog: true,
        data: [],
        SUBJECTTYPEOBJ: this.$utils.getlocalStorage('SUBJECTTYPEOBJ'),
        type: 0,
        tianbaoType: this.$utils.getlocalStorage('tianbaoType'),
        cyc: 0,
        byb: 0,
        wyw: 0,
        dyd: 0,
        show:false,
        item:null,
        open: {
          title: '',
          content: []
        }
      }
    },
    mounted() {
      this.type = this.$route.query.bog
      this.$utils.removelocalStorage("rateshow")
    },
    methods: {
      close(){
        let _this = this;
        if(_this.jixuto){
          if (this.$utils.getPhoneStatus(this)) {
            let obj = JSON.parse(this.item.spare1)
            let obj1 = Object.assign(this.item.spare1, obj);
            this.$rate.fxg = obj.fxg
            this.$rate.cyc = obj.cyc
            this.$rate.wyw = obj.wyw
            this.$rate.byb = obj.byb
            this.$utils.setlocalStorage("userZhiYuanBatch", this.item)
            this.$utils.setlocalStorage('tianbaoModel', this.type)
            this.getSaveinfo();
          }
        } else {
          this.show = false
        }
      },

      kaishitianbao1(item){
        this.item = item;
        if(item.spare){
          if(item.spare4){
            this.open.content = []
            this.open.content.push(item.spare4)
          }
          this.show = true;
        } else {
         if (this.$utils.getPhoneStatus(this)) {
              this.kaishitianbao(item);
           // this.getSaveinfo();
         }
        }
      },

      // 老高考
      kaishitianbao(item) {
        let obj = JSON.parse(this.item.spare1)
        if(obj.showcode == undefined){
          obj.showcode = false;
        }
        this.$utils.setlocalStorage("showcode", obj.showcode)
        let obj1 = Object.assign(this.item, obj);
        this.$rate.fxg = obj.fxg
        this.$rate.cyc = obj.cyc
        this.$rate.wyw = obj.wyw
        this.$rate.byb = obj.byb
        this.$utils.setlocalStorage("userZhiYuanBatch", this.item)
        this.$utils.setlocalStorage('tianbaoModel', this.type)
        this.getSaveinfo();


      },
      toTianBao() {

        this.$utils.removelocalStorage("volunteerTableInfo")
        this.$utils.removelocalStorage("zyadd")
        if (this.type == 1) {
          this.$utils.removelocalStorage("zyyixuan");
          this.$router.push('/zhiyuanList_zyselect')
        } else if(this.type == 0) {
          this.$utils.removelocalStorage("zyyixuan")
          if (this.tianbaoType == 0) {
            this.$router.push('/zhuan_newgaokao')
          } else if (this.tianbaoType != 0) {
            this.$router.push('/zhuan_newgaokao')
          }
        } else if(this.type == 2){
          this.$utils.removelocalStorage("zyyixuan")
          this.$router.push('/yijiantianbao')
        }
      },
      getSaveinfo() {
        let  userZhiYuanBatch = this.$utils.getlocalStorage("userZhiYuanBatch");
        if(userZhiYuanBatch!=null){

        }

        let cyc = this.$utils.getlocalStorage("ZhiYuancyc");
        let byb = this.$utils.getlocalStorage("ZhiYuanbyb");
        let wyw = this.$utils.getlocalStorage("ZhiYuanwyw");
        let dyd = this.$utils.getlocalStorage("ZhiYuandyd");
        if (!(cyc != null || byb != null || wyw != null || dyd != null)
        ||cyc.ids.length==undefined
        ||wyw.ids.length==undefined
        ||byb.ids.length==undefined
        ||dyd.ids.length==undefined) {
          let obj = {
            ids: [],
            map: {}
          };
          this.$utils.setlocalStorage("ZhiYuancyc", obj)
          this.$utils.setlocalStorage("ZhiYuanbyb", obj)
          this.$utils.setlocalStorage("ZhiYuanwyw", obj)
          this.$utils.setlocalStorage("ZhiYuandyd", obj)
          this.toTianBao();
        } else {
          console.log(cyc)
          if (cyc.ids.length != 0 || byb.ids.length != 0 || wyw.ids.length != 0 || dyd.ids.length != 0) {
            this.$confirm('<strong>系统为您保存上次志愿操作,是否在上次志愿操作上继续完善?</strong><br/>是：在原基础上继续填报<br/>否：清除历史，创建一张新的志愿单', '操作提示', {
              confirmButtonText: '是',
              cancelButtonText: '否',
              type: 'warning',
              distinguishCancelAndClose: true,
              dangerouslyUseHTMLString: true
            }).then(() => {
              this.toTianBao();
            }).catch(action => {
              if (action == 'cancel') {
                let obj = {
                  ids: [],
                  map: {}
                };
                this.$utils.setlocalStorage("ZhiYuancyc", obj)
                this.$utils.setlocalStorage("ZhiYuanbyb", obj)
                this.$utils.setlocalStorage("ZhiYuanwyw", obj)
                this.$utils.setlocalStorage("ZhiYuandyd", obj)
                this.toTianBao();
              }
              console.log(action)
            });
            // callback: action => {
            //   console.log(action)
            //   if (action == 'confirm') {
            //     // _this.$router.push('/login')
            //   }
            // }
            // this.toTianBao();
          } else {
            this.toTianBao();
          }
        }
      },
      getData() {
        let _this = this;
        this.$req.queryAllbyFirstYear({
          provincialArea: this.$utils.getlocalStorage('areaInfo').areaId,
          provincialSubject: this.$utils.getlocalStorage('scoreInfo').scoreSubject,
        }).then(function(response) {
          _this.data = response.data
        })
      },


    },
    created() {
      console.log("created")
      this.$utils.removelocalStorage("userZhiYuanBatch")
      let _this = this;
      _this.$http.get(_this.$resourcesUrl + "/data/picixian.json?time=" + new Date().getTime()).then(function(
        resp) {
          _this.open = resp
          _this.jixuto = resp.to
      })
      this.getData()
    }


  }
</script>

<style scoped>
  /* 新 */
  .miansdas {
    margin-bottom: 0px;
    width: 100%;
    height: 85px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    background: url(../../assets/img/beibeiebei.png)no-repeat;
    background-size: 100% 100%;
  }

  .miansdas img {
    width: 90px;
    height: 90px;
    border-radius: 50%;
  }

  .miansdas span {
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #FFFFFF;
  }

  .tiaobaodan {
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 40px;
    box-sizing: border-box;
    flex-wrap: wrap;
  }

  .tiaobaodan .tbheader {
    display: flex;flex-direction: row;background-color: #29A7E1;
    width: 100%;
    border-radius: 5px;
  }
  .tiaobaodan .tbheader .item{
    color: white;
  }
  .tiaobaodan .tbrow {
    display: flex;flex-direction: row;
    width: 100%;

  }
  .tiaobaodan .item{
    text-align: center;
    font-size: 16px;
    height: 50px;
    line-height: 50px;

  }
  .tiaobaodan .tbrow .item{
    border: 0.5px solid #E0E0E0;
    margin: 3px 0;

  }

  .tiaobaodan .tbrow .item:nth-of-type(1){
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
  }
  .tiaobaodan .tbrow .item:nth-of-type(6){
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
  }

  .tiaobaodan .item:nth-of-type(1) {
    width: 300px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;


  }
  .tiaobaodan .item .tbt{
    border : 1px solid #F76636;
    border-radius: 15px;
    height: 18px;
    line-height: 18px;
    width: 18px;
    font-weight: 400;
    font-size: 14px;
    color: #F76636;
    margin-left: 8px;
    cursor: pointer;

  }
  .tiaobaodan .item:nth-of-type(2) {
    width: 180px;
  }
  .tiaobaodan .item:nth-of-type(3) {
    width: 180px;
  }
  .tiaobaodan .item:nth-of-type(4) {
    width: 180px;
  }
  .tiaobaodan .item:nth-of-type(5) {
    width: 170px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .tiaobaodan .item:nth-of-type(6) {
    width: 240px;
    display: flex;
    justify-content: space-around;
    align-items: center;
  }
  .tiaobaodan .tbbtn{
      width: 90px;
      font-size: 14px;
      height: 25px;
      line-height: 23px;
      border:  rgba(246, 100, 100, 1) 1px solid;
      color:  rgba(246, 100, 100, 1);
      border-radius: 8px;
      cursor: pointer;

  }

  .tiaobaodan_index {
    cursor: pointer;
    margin-bottom: 20px;
    width: 280px;
    height: 300px;
    border: 1px solid #E9E9E9;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .tiaobaodan_index .tian_top {
    border-radius: 8px 8px 0 0;
    width: 280px;
    height: 52px;
    background: #649EE7;
    font-size: 24px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #FFFFFF;
    text-align: center;
    line-height: 52px;
  }

  .tiaobaodan_index .xiamian {
    width: 100%;
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
  }

  .tiaobaodan_index .xiamian .tian_fen {
    width: 107px;
    height: 107px;
    border: 1px solid #FF6666;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .tiaobaodan_index .xiamian .tian_fen span {
    font-size: 36px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #FF6666;
    height: 36px;
    display: flex;
    align-items: center;
  }

  .tiaobaodan_index .xiamian .tian_fen label {
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    height: 36px;
    display: flex;
    align-items: end;
  }

  .tiaobaodan_index .xiamian span {
    font-size: 22px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
  }

  .tiaobaodan_index .xiamian label {
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #787878;
  }

  .tiaobaodan_index .xiamian .kaishi {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 193px;
    height: 46px;
    background: linear-gradient(83deg, #F20E23, #F76636);
    border-radius: 23px;
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #FFFFFF;
  }


  /* 新 */

  .beijngsd {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100px;
    background: url(../../assets/gerenzhongxin/geren21.png)no-repeat;
    background-size: 100% 100%;
    font-size: 28px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #FFFFFF;
  }

  .beijngsd span {
    display: flex;
    width: 44px;
    height: 2px;
    opacity: 0.48;
    border-radius: 1px;
    background-color: #FFFFFF;
  }

  .beijngsd span:nth-of-type(1) {
    margin-right: 14px;
  }

  .beijngsd span:nth-of-type(2) {
    margin-left: 14px;
  }

  .centen {
    width: 1280px;
    margin: 0 auto;
    margin-top: 20px;
  }

  .manpin {
    width: 100%;
    height: auto;
    padding-top: 90px;
    /* padding: 40px 0; */
    box-sizing: border-box;
    background: #EBE9E9;
  }

  .main {
    padding-bottom: 40px;
    display: flex;
    justify-content: space-between;
    background: #EBE9E9;
  }

  .main_l {
    /* background: rgba(251, 251, 251, 1); */
    width: 210px;
  }

  .topxiang {
    width: 100%;
    height: 194px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 1);
    border-radius: 5px;
    margin-bottom: 30px;
  }

  .topxiang img {
    width: 102.73px;
    height: 102.73px;
    margin-bottom: 20px;
  }

  .topxiang span {
    width: 144px;
    height: 22px;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #333333;
    opacity: 1;
  }

  /* .jibenxinxi {
    width: 290px;
    height: auto;
    background: rgba(255, 255, 255, 1);
    opacity: 1;
    border-radius: 5px;
    padding: 15px 0;
    box-sizing: border-box;
  }

  .jibenxinxi figure {
    width: 100%;
    height: 60px;
    display: flex;
    align-items: center;
    cursor: pointer;
  }

  .jibenxinxi figure img {
    height: 44px;
    margin-left: 22px;
  }

  .jibenxinxi figure figcaption {
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #666666;
    margin-left: 10px;
  }
 */
  .beijngsdtu {
    background: url(../../assets/gerenzhongxin/geren26.png)no-repeat;
    background-size: 100% 100%;
  }

  .texts {
    color: #F53824 !important;
  }

  .xiaoxi {
    margin-left: 10px;
    background: url(../../assets/gerenzhongxin/geren18.png)no-repeat;
    background-size: 100% 100%;
    width: 33px;
    height: 23px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
  }

  .main_r {
    width: 1190px;
    min-height: 578px;
    background: rgba(255, 255, 255, 1);
    opacity: 1;
    border-radius: 5px;
    padding: 20px;
    padding-top: 0;
    margin-left: 20px;
    box-sizing: border-box;
  }

  .mainr_top {
    width: 100%;
    height: 68px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid rgba(0, 0, 0, 0.10196078431372549);
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #333333;
  }

  .mainr_top img {
    width: 7px;
    height: 24px;
    margin-right: 10px;
  }

  .youxinxi {
    padding: 33px 20px 0 20px;
    width: 310px;
    height: 230px;
    background: rgba(253, 251, 247, 1);
    border: 1px solid #FBF5E9;
    opacity: 1;
    border-radius: 5px;
    position: absolute;
    top: 24px;
    right: 20px;
  }

  .mainr_bot {
    width: 100%;
    position: relative;
  }

  .youxinxi label {
    position: absolute;
    top: -14px;
    left: 20px;
    width: 92px;
    height: 28px;
    background: rgba(244, 166, 65, 1);
    opacity: 1;
    border-radius: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
  }

  .youxinxi figure {
    display: flex;
    margin-bottom: 13px;
  }

  .youxinxi figure img {
    margin-right: 4px;
    width: 18px;
    height: 20px;
  }

  .youxinxi figure figcaption {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #5A4F40;
  }

  .form {
    width: auto;
    height: auto;
    display: flex;
    flex-direction: column;
    margin-top: 30px;
    margin-left: 40px;
  }

  .form li {
    width: auto;
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    position: relative;
  }

  .form li label {
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #333333;
    width: 80px;
    text-align: right;
  }

  .form li i {
    color: #F53824;
    margin: 0 5px;
  }

  .form li input {
    width: 372px;
    height: 40px;
    background: rgba(255, 255, 255, 0.39);
    border: 1px solid #E0E0E0;
    opacity: 1;
    border-radius: 5px;
    padding: 0 10px;
    box-sizing: border-box;

  }

  .duanxin {
    border: none;
    position: absolute;
    top: 5px;
    left: 240px;
    width: 120px;
    height: 30px;
    background: linear-gradient(180deg, #F53824 0%, #F45D26 100%);
    opacity: 1;
    border-radius: 2px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
  }

  .shoujiinp {
    width: auto;
    display: flex;
    position: relative;
  }

  .form li {
    position: static;
  }

  /* .form li .shoujiinp input{width: auto;} */
  .form li .shoujiinp span {
    margin-top: 5px;
  }

  .form li span {
    margin-left: 5px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #F53824;
    opacity: 1;
  }

  .inps {
    width: 118px;
    height: 40px;
  }

  .inps:nth-of-type(1) {
    margin-right: 9px;
  }

  .inps:nth-of-type(2) {
    margin-right: 9px;
  }

  .inpda {
    width: 372px;
    height: 40px;
    background: rgba(255, 255, 255, 0.39);
    opacity: 1;
  }

  .baochuan {
    border: none;
    margin-left: 115px;
    margin-top: 20px;
    width: 140px;
    height: 46px;
    background: linear-gradient(92deg, #F53824 0%, #F45D26 100%);
    opacity: 1;
    border-radius: 23px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
  }

  @media (max-width:1400px) {
    .centen {
      /* width: auto; */
    }
  }

  @media (min-width:750px) {
    .mainr_bot2 {
      display: none;
    }
  }

  @media (max-width:750px) {
    .miansdas {
      height: 100px;
      margin-bottom: 10px;
    }

    .miansdas img {
      width: 50px;
      height: 50px;
    }

    .miansdas span {
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #FFFFFF;
    }


    .mainr_bot {
      display: none;
    }

    .beijngsd {
      height: 70px;
      font-size: 24px;
    }

    .main {
      flex-direction: column;
    }

    .main_l {
      width: 100%;
    }

    .jibenxinxi::-webkit-scrollbar {
      display: none;
    }

    .manpin {}

    .topxiang {
      flex-direction: row;
      width: 100%;
      height: auto;
      justify-content: revert;
      margin-bottom: 15px;
    }

    .topxiang span {
      margin-left: 20px;
    }

    .topxiang img {
      margin: 0;
      height: 60px;
      width: 60px;
    }

    .jibenxinxi {
      width: 100%;
      height: auto;
      display: flex;
      flex-direction: row;
      overflow-y: hidden;
      overflow: auto;
      /* background: whitesmoke; */
    }

    .jibenxinxi figure {
      flex-shrink: 0;
      width: auto;
      margin: 0 5px;
    }

    .beijngsdtu {
      /* background: url(../../assets/gerenzhongxin/sj_geren26.png)no-repeat; */
      background: none;
      /* background-size: 100% 100%; */
      border-bottom: 1px solid #F53824;
    }

    .jibenxinxi figure img {
      margin-left: 0;
    }

    .youxinxi2 {
      padding: 33px 20px 0 20px;
      width: 100%;
      height: 230px;
      background: rgba(253, 251, 247, 1);
      border: 1px solid #FBF5E9;
      opacity: 1;
      border-radius: 5px;
      position: relative;
    }

    .mainr_bot2 {
      width: 100%;
      margin-top: 20px;
      /* position: relative; */
    }

    .youxinxi2 label {
      position: absolute;
      top: -14px;
      left: 20px;
      width: 92px;
      height: 28px;
      background: rgba(244, 166, 65, 1);
      opacity: 1;
      border-radius: 14px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #FFFFFF;
    }

    .youxinxi2 figure {
      display: flex;
      margin-bottom: 13px;
    }

    .youxinxi2 figure img {
      margin-right: 4px;
      width: 18px;
      height: 20px;
    }

    .youxinxi2 figure figcaption {
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #5A4F40;
    }

    .main_r {
      width: 100%;
      height: auto;
      display: flex;
      flex-direction: column;
      margin-left: 0;
    }


    .form {
      margin-left: 0;
    }

    .shoujiinp {
      flex: 1;
      display: flex;
      flex-direction: column;
      position: relative;
    }

    .form li {
      position: static;
    }

    .form li .shoujiinp input {
      width: auto;
    }

    .form li .shoujiinp span {
      margin-top: 5px;
    }

    .form li label {
      flex-shrink: 0;
    }

    .duanxin {
      right: 10px;
      left: auto;
      top: 5px;
      width: 85px;
      border-radius: 5px;
      font-size: 10px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/tianbao/tiaobaozhiyuan.vue